(() => {
  'use strict';

  angular
    .module('app.settings')
    .controller('DFPModalController', DFPModal);

  DFPModal.$inject = ['$http', 'close', 'dfp'];

  function DFPModal($http,  close, dfp) {
    const vm = this;
    const { token, accountId, dfpUrl } = window.DFP_CONFIG;
    vm.settings = {};

    vm.save = () => {
      $http({
        url: dfpUrl + 'request',
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + token },
        data: {
          accountId,
          networkCode: vm.settings.networkCode
        }
      }).then(({ data: { status, message } }) => {
        close({ status, message }, 500);
      });
    };
  }
})();
